import React from 'react'
import { ExternalSystem, NewExternalSystem } from '@cbgms/api/modules/shops/external-systems'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNotifier } from '@cbgms/base/notifier'
import { useParams } from 'react-router-dom'
import ExternalSystemForm from './ExternalSystemForm'
import { getExternalSystem, updateExternalSystem } from './state/actions'
import { Loader } from '@carsys/ui'

const EditExternalSystemForm = () => {
  const dispatch = useDispatch()
  const { companyUUID, shopID, externalSystemUUID } = useParams<{ companyUUID: string; shopID: string; externalSystemUUID: string }>()
  const [initialValues, setInitialValues] = React.useState<ExternalSystem | null>(null)
  const { t } = useTranslation()
  const notifier = useNotifier()

  React.useEffect(() => {
    const asyncFunc = async () => {
      const response = await dispatch(getExternalSystem(companyUUID, shopID, externalSystemUUID))
      const data = response.Data
      setInitialValues(data)
    }
    asyncFunc()
  }, [shopID, externalSystemUUID])

  const onSubmit = (values: NewExternalSystem) => {
    dispatch(updateExternalSystem(companyUUID, shopID, externalSystemUUID, values))
  }

  const onSubmitSuccess = () => {
    notifier.success(t('external-systems.edit-success'))
  }

  if (!initialValues) return <Loader loading />

  return (
    <ExternalSystemForm
      form='edit-external-system'
      initialValues={initialValues}
      onSubmitSuccess={onSubmitSuccess}
      onSubmit={onSubmit}
      redirectToURL={`/companies/${companyUUID}/shops/edit/${shopID}#externalsystems`}
    />
  )
}

export default EditExternalSystemForm
